import React from "react";
import { useNavigate } from "react-router-dom";
import AuthForm from "../../Components/auth/AuthForm";
import LogoDark from "../../assets/logo.svg";
import LogoLight from "../../assets/logo-rewards-light.svg";
import styles from "./Portal.module.scss";

const PortalSignIn: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.SignInPage}>
      <div className={styles.SignInCard}>
        <picture>
          <source srcSet={LogoLight} media="(prefers-color-scheme: dark)" />
          <img src={LogoDark} alt="Sally" className={styles.SignInLogo} />
        </picture>
        <p className={styles.SignInSubtitle}>Sign in to see your rewards</p>
        <AuthForm
          mode="signin"
          onSuccess={() => {}}
          showFooter
          below={
            <p className={styles.SignInFooterPrompt}>
              New here?{" "}
              <span
                className={styles.SignInFooterLink}
                onClick={() => navigate("/signup")}
              >
                Create an account
              </span>
            </p>
          }
        />
      </div>
    </div>
  );
};

export default PortalSignIn;
